import React from 'react';
import {
  Page,
  Layout,
  Card,
  TextContainer,
  Heading,
  Text,
  Link
} from '@shopify/polaris';
import '@shopify/polaris/build/esm/styles.css';
import { AppProvider } from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';

const PrivacyPolicy = () => {
  return (
    <AppProvider i18n={enTranslations}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
        <div style={{ marginBottom: '20px' }}>
          <Link url="/">← Back to Home</Link>
        </div>
        
        <Card sectioned>
          <TextContainer>
            <Heading>Privacy Policy for Shopify Product Editor Pro</Heading>
            <Text variant="bodyLg">Last Updated: April 11, 2025</Text>
            
            <Heading element="h3">1. Introduction</Heading>
            <Text>Elevia Solutions LLC ("we," "our," or "us") respects your privacy and is committed to protecting your personal data. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our Shopify Product Editor Pro application ("Application").</Text>
            
            <Heading element="h3">2. Information We Collect</Heading>
            <Text>We collect information that you provide directly to us when you:</Text>
            <ul>
              <li>Register for an account</li>
              <li>Use our Application features</li>
              <li>Contact our customer support</li>
              <li>Subscribe to our services</li>
              <li>Respond to surveys or communications</li>
            </ul>
            
            <Text>This information may include:</Text>
            <ul>
              <li>Name and contact details</li>
              <li>Shopify store information</li>
              <li>Billing information</li>
              <li>Product data from your Shopify store</li>
              <li>Usage data and preferences</li>
            </ul>
            
            <Heading element="h3">3. How We Use Your Information</Heading>
            <Text>We use the information we collect to:</Text>
            <ul>
              <li>Provide, maintain, and improve our Application</li>
              <li>Process transactions and manage your account</li>
              <li>Send you technical notices, updates, and support messages</li>
              <li>Respond to your comments and questions</li>
              <li>Develop new products and services</li>
              <li>Monitor and analyze usage patterns</li>
              <li>Protect the security and integrity of our Application</li>
            </ul>
            
            <Heading element="h3">4. Shopify Data Access</Heading>
            <Text>Our Application requires access to your Shopify store data to function properly. We access only the data necessary to provide our services, such as product information, inventory, and pricing details. We do not access customer personal data beyond what is necessary for the functioning of our Application.</Text>
            
            <Heading element="h3">5. Data Sharing and Disclosure</Heading>
            <Text>We may share your information with:</Text>
            <ul>
              <li>Service providers who perform services on our behalf</li>
              <li>Professional advisors, such as lawyers and accountants</li>
              <li>Regulatory authorities, when required by law</li>
              <li>Business partners, with your consent</li>
            </ul>
            
            <Text>We do not sell your personal information to third parties.</Text>
            
            <Heading element="h3">6. Data Security</Heading>
            <Text>We implement appropriate technical and organizational measures to protect your personal data against unauthorized or unlawful processing, accidental loss, destruction, or damage. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.</Text>
            
            <Heading element="h3">7. Data Retention</Heading>
            <Text>We retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law.</Text>
            
            <Heading element="h3">8. Your Rights</Heading>
            <Text>Depending on your location, you may have certain rights regarding your personal information, including:</Text>
            <ul>
              <li>Access to your personal data</li>
              <li>Correction of inaccurate data</li>
              <li>Deletion of your data</li>
              <li>Restriction or objection to processing</li>
              <li>Data portability</li>
              <li>Withdrawal of consent</li>
            </ul>
            
            <Text>To exercise these rights, please contact us using the information provided in the "Contact Us" section.</Text>
            
            <Heading element="h3">9. Children's Privacy</Heading>
            <Text>Our Application is not intended for children under 16 years of age. We do not knowingly collect personal information from children under 16. If you are a parent or guardian and believe your child has provided us with personal information, please contact us.</Text>
            
            <Heading element="h3">10. Changes to This Privacy Policy</Heading>
            <Text>We may update this Privacy Policy from time to time. The updated version will be indicated by an updated "Last Updated" date. We encourage you to review this Privacy Policy periodically.</Text>
            
            <Heading element="h3">11. Contact Us</Heading>
            <Text>If you have questions or concerns about this Privacy Policy or our data practices, please contact us at:</Text>
            <Text>Elevia Solutions FZ-LLC</Text>
            <Text>Email: privacy@elevia-solutions.com</Text>
            <Text>Address: Compass Building, Al Shohada Road</Text>
            <Text>Ras Al Khaimah, FDRK7068</Text>
            <Text>United Arab Emirates</Text>
          </TextContainer>
        </Card>
      </div>
    </AppProvider>
  );
};

export default PrivacyPolicy;
